import Role from 'constants/role';
import { useHasRole } from 'hooks/useHasRole';
import React, { useMemo } from 'react';
import {
  ReferenceInput, AutocompleteInput, required, useRecordContext, useInput,
} from 'react-admin';

const optionText = (r) => (r?.id
  ? [
    ['ID', r.id],
    ['NAME ', `${r.information.firstName} ${r.information.lastName}`],
    r.channels?.length
      ? ['CH ', r.channels[0].title || r.channels[0].id]
      : null,
  ].filter(Boolean).map(([key, value]) => `${key}: ${value}`).join(' | ')
  : '');
function UserReferenceInput({
  validate, sameOrg = false, disabled, ...props
}) {
  const hasRole = useHasRole();
  const record = useRecordContext();

  // Access orgId field value using useInput
  const { field: orgIdField } = useInput({ source: 'orgId' });
  const orgIdValue = orgIdField?.value;

  if (!hasRole(Role.USER_VIEW)) {
    return null;
  }

  const defaultFilter = useMemo(() => {
    // Use orgIdValue for create forms, record for edit forms
    const orgId = orgIdValue || record?.orgId;

    return {
      _attributes: 'id,information,channels',
      ...(sameOrg && orgId ? { orgId } : {}),
    };
  }, [sameOrg, orgIdValue, record?.orgId]);

  return (
    <ReferenceInput reference="users" filter={defaultFilter} {...props}>
      <AutocompleteInput
        defaultValue={null}
        optionText={optionText}
        filterToQuery={(searchQuery) => ({
          searchQuery,
        })}
        matchSuggestion={() => true}
        validate={validate}
        sx={{ width: 420 }}
        disabled={disabled}
      />
    </ReferenceInput>
  );
}

UserReferenceInput.defaultProps = {
  source: 'userId',
  label: 'User',
  validate: [],
};

export default UserReferenceInput;
